<template>
  <BaseSelect v-bind="$attrs"
              :value="value"
              :options="items"
              :filterable="false"
              :loading="pendingCity"
              text-key="Present"
              @input="$emit('input', $event)"
              @search="onCitySearch"
              @blur="items = []">
    <template v-if="!currentText"
              v-slot:dropdown-placeholder>
      {{ $tGlobal('Start typing') }}
    </template>
  </BaseSelect>
</template>

<script>
  import axios, {CancelToken} from 'axios'

  let cancel;

  export default {
    name: 'NovaPoshtaAddress',
    props: {
      value: [String, Object]
    },
    data() {
      return {
        pendingCity: false,
        items: [],
        currentText: null
      }
    },
    methods: {
      onCitySearch(value) {
        this.pendingCity = true

        value = value ? value.trim() : null
        this.currentText = value

        if (cancel) {
          cancel()
        }

        axios.post('https://api.novaposhta.ua/v2.0/json/', {
          "apiKey": "bf87c735810360239c039d816b9b779e",
          "modelName": "Address",
          "calledMethod": "searchSettlements",
          "methodProperties": {
            "CityName": value,
            "Limit": 5
          }
        }, {
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancel = c;
          })
        }).then(({data}) => {
          this.items = this.$get(data.data, '[0].Addresses')
        }).finally(() => {
          this.pendingCity = false
        })
      }
    }
  }
</script>

<style lang="less">

</style>
